const messages = {
  global: {
    tenant: "Tenant|Tenants",
    tenants: "0 Tenants|1 Tenant|{n} Tenants",
    site: "Site|Sites",
    sites: "0 Sites|1 Site|{n} Sites",
    day: "Day|Days",
    days: "0 Days|1 Day|{n} Days",
    any: "Any",
    or: "or",
    options: "Option|Options",
    attachments: "Attachments",
    noAttachments: "No attachments",
    error: "Error",
    all: "All",
    list: "List",
    onDate: "on",
    atTime: "at",
    by: "by",
    copy: "copy",
    clone: "clone",
    propertiesShort: "Prop.",
    role: "Role|Roles",
    assignedRoles: "Assigned role|Assigned roles",
    anonymousUser: "Anonymous user",
    unset: "Unset",
    picture: "Picture|Pictures",
  },
  action: {
    ok: "OK",
    apply: "Apply",
    confirm: "Confirm",
    cancel: "Cancel",
    close: "Close",
    select: "Select",
    yes: "Yes",
    no: "No",
    save: "Save",
    create: "Create",
    add: "Add",
    edit: "Edit",
    complete: "Complete",
    stopEdit: "Stop editing",
    refresh: "Refresh",
    clear: "Clear",
    clearAll: "Clear all",
    remove: "Remove",
    upload: "Upload",
    download: "Download",
    delete: "Delete",
    back: "Back",
    send: "Send",
    search: "Search",
    newEllipsis: "New...",
    moreEllipsis: "More...",
    addEllipsis: "Add...",
    selectEllipsis: "Select...",
    copyEllipsis: "Copy...",
    cloneEllipsis: "Clone...",
    captureEllipsis: "Capture...",
    goto: "Go to: {name}",
    loginWithPasskey: "Sign in with a passkey",
    loginWithMicrosoft: "Sign in with Microsoft",
    confirmQuantity: "Confirm quantity",
    showBarcode: "Show barcodes",
    developerMode: "Developer mode",
    showLotVisual: "Show lot visual",
    showAuditVisual: "Show audit visual",
    colorModeSystem: "System",
    colorModeLight: "Light",
    colorModeDark: "Dark",
    requestQuantityInput: "manual",
    scan: "Scan",
    scanBarcode: "Scan barcode",
    scanItem: "Scan item",
    addToList: "Add to list",
    addPasskey: "Add passkey",
    linkMicrosoftAccount: "Link Microsoft account",
    copyToClipboard: "Copy",
    copyToExtension: "Copy",
    placeOrder: "Place order",
    fillDemands: "Sync demands",
    acceptOrder: "Accept order",
    consumeListed: "Consume list",
    printPreviewEllipsis: "Label print preview...",
    printEllipsis: "Print...",
    showPast: "Show past",
    resendEmail: "Resend email",
    ignore: "Ignore",
    discardAndLeave: "Discard and leave",
    ignoreSignature: "Ignore signature (lot / best-before / expiry) and show item totals",
    reorder: "Reorder",
    addToDraft: "Add to draft",
    addToCart: "Add to cart",
    addToNewOrderEllipsis: "Add to new order...",
    addToOrderDraft: "Add to cart",
    verifyConnection: "Verify connection",
    ttsRead: "Read aloud",
    asrRecognize: "Speech recognition",
    viewMail: "View Mail",
    viewMailInMyLanguage: "View Mail in my language",
    "show-all": "Show all",
    revoke: "Revoke",
    cancelOrderShort: "Cancel",
    triggeredPageReload: "Reloading app -> {reason}",
    goHome: "Go to home",
    undoStockChange: "Undo stock change (as far as possible)",
  },
  status: {
    none: "",
    pending: "Pending",
    inProgress: "In progress",
    completed: "Completed",
    succeeded: "Succeeded",
    cancelled: "Cancelled",
    failed: "Failed",
    orderCancelledShort: "Cancelled",
    loadingEllipsis: "Loading...",
    savingEllipsis: "Saving...",
  },
  reason: {
    reloadPageForcedByServer: "Forced by server",
    reloadPageNewServerBuild: "New server build",
    reloadPageAssetChanged: "New assets",
    partialDelivery: "Partial delivery",
    partialDeliveryIgnored: "Partial delivery (ignored)",
    partialDeliveryReordered: "Partial delivery (reordered)",
    partialDeliveryMissingItemsCopiedToDraftOrder: "Partial delivery (planned)",
  },
  enum: {
    restockPullType: {
      "0": "Order",
      "1": "Min-Max",
      "2": "Bin Min-Max",
    },
  },
  instruction: {
    confirmQuantitySummary: "Confirm quantity after scanning instead of booking quanity directly.",
    showBarcodeSummary: "Show barcodes of stock and delivered items in lists.",
    developerModeSummary: "Show information needed for debugging (a.k.a. debug mode).",
    showLotVisualSummary: "Show a visual indication for help differentiate between lots.",
    showAuditVisualSummary: "Show users with colored background to help differentiate between different users at a glance.",
    restockPullTypeOriginalPack: "scan when pack empty",
    provideRequiredFields: "Please provide all required fields",
    requiresAtLeaseTwoEntries: "At least two entries required",
    undoStockChangeConfirm: "Reverse this stock change? Where stock no longer covers the original change, the reversal is clamped to what is actually available.",
    unsavedChangesTitle: "Unsaved changes",
    unsavedChangesLeaveConfirm: "You have unsaved changes. Leave this page and discard them?",
  },
  help: {
    assignItemsToSupplierWithoutItems: "Edit this supplier to assign items.",
  },
  placeholder: {
    newSupplier: "<New supplier>",
  },
  validation: {
    required: "Field is required",
    minLength: "Field must be at least {min} characters",
    maxLength: "Field must be at most {max} characters",
    codeRequired: "Code is required",
    nameRequired: "Name is required",
    emailRequired: "Email is required",
    emailMustBeValid: "Email must be a valid email",
    emailType: "Email must be valid",
    passwordRequired: "Password is required",
    passwordMinLength: "Password must be at least {min} characters",
    confirmPasswordRequired: "Confirm password is required",
    passwordConfirmMatch: "Passwords must match",
    requiredPermissions: "Required permissions: {permissions}",
    duplicateCodes: "Duplicate codes: {duplicates}",
  },
  statement: {
    contentCopied: "Content copied",
    itemCopied: "Item {item} copied",
    emailSent: "Email has been sent.",
    supplierSaved: "Supplier {supplierCode} saved",
    itemBlockSaved: "Item block saved",
    orderIsAccepted: "Order is accepted",
    orderIsCancelled: "Order is cancelled",
    receivingIsAccepted: "Receiving is accepted",
    foreignItemSaved: "Foreign item saved",
    consumptionSaved: "Consumption saved",
    partialDeliveryMissingItemsCopiedToDraftOrder: "Missing items copied to draft order",
    partialDeliveryMissingItemsReordered: "Missing items reordered",
    partialDeliveryIgnored: "Partial delivery ignored",
  },
  error: {
    accessDenied: "Access denied",
    pageAccessDenied: "Access denied to this page",
    copiedError: "Error at copying",
    axiosErrorMessage: "{code}: {message}",
    apiError: "API error: {error}",
    noData: "No data available",
    unknownItem: "Unknown item",
    noLabelsToPrint: "No labels to print",
    nothingToSave: "Nothing to save",
    noCode: "No code",
    noItemGtin: "No GTIN for item #{itemId}",
    noHtmlMailAvailable: "No HTML mail available",
    failedToLoadHtmlMail: "Failed to load HTML mail",
    supplierHasNoAssignedItems: "Supplier '{supplierName}' has no assigned items",
    baseItemNotFoundForItem: "Base item #{baseItemId} not found for item '{itemCode}'",
    itemNotManagedByDemand: "Item '{itemCode}' is not managed by demand",
    itemManagedByStockLevels: "Item '{itemCode}' is managed by stock levels",
    noItemSupplierAssigned: "No supplier assigned",
    noSupplierFoundForItem: "No supplier found for item '{itemCode}'",
    noSupplierItemFoundForItem: "No supplier item found for item '{itemCode}' with supplier #{supplierId}, supplier item {{supplierItemId}} ({supplierItemCode})",
    supplierSaveError: "Error while saving supplier: {error}",
    requiresValidSignature: "Signature tracking required / calculated signature disallowed '{itemCode}'",
    notEnoughStockShort: "Not enough stock! Requested {quantity} {unitName}, available {available} {unitName}",
    notEnoughStock: "Not enough stock for item '{itemCode}', requested {quantity} {unitName}, available {available} {unitName}",
    invalidPatientCode: "Invalid patient no: {patientCode}",
  },
  menu: {
    home: "Home",
    controlling: "Control",
    masterdata: "Master data",
    administration: "Admin",
    "manage-users": "Manage users",
    "manage-tenants": "Manage tenants",
    "manage-sites": "Manage sites",
    tenant: "Tenant",
    site: "Site",
    items: "Items",
    "item-edit": "Artikel",
    "itemblocks": "Item blocks",
    "itemblock-create": "Create item block",
    "foreign-items": "PMS items",
    suppliers: "Suppliers",
    "info-request": "Info",
    "info-device": "Device",
    deliveries: "Deliveries",
    orders: "Orders",
    "order-create": "Create order",
    "order-list": "Order list",
    receivings: "Goods receipt",
    consumption: "Consumption",
    "consumption-list": "Consumption list",
    stocks: "Stocks",
    "stock-changes": "Stock changes",
    "stock-demand": "Stock Demand",
    "order-demand": "Order Demand", 
    "stock-receipt": "Stock receipt",
    "stock-issue": "Stock issue",
    "label-item": "Item labels",
    "label-box": "Box labels",
    statistics: {
      consumption: "Consumptions",
      expiry: "Expirations",
    },
    "label-printers": "Labelprinter",
    "label-printer-edit": "Printer",
    "label-templates": "Label templates",
    "label-template-edit": "Label template",
    "order-confirmation": "Order confirmation",
  },
  language: {
    en: "English",
    de: "German",
    fr: "French",
  },
  field: {
    generic: {
      code: "Code",
      name: "Name",
      status: "Status",
      description: "Description",
      general: "General",
      password: "Password",
      token: "Token",
      rowActions: "",
      id: "ID",
      email: "Email",
      quantity: "Quantity",
      item: "Item",
      tradeItem: "GTIN|GTINs",
      supplier: "Supplier|Suppliers",
      customer: "Customer|Customers",
      address: "Address",
      phone: "Phone",
      created: "Created",
      updated: "Updated",
      itemblock: "ItemBlock",
      company: "Company",
      contactName: "Contact name",
      order: "Order|Orders",
      delivery: "Delivery|Deliveries",
      linesCount: "# of lines",
      language: "Language",
    },
    user: {
      fullName: "Full name",
      fullNamePlaceholder: "First name Last name",
    },
    emailQueue: {
      statusLabel: "Email status",
    },
    masterdata: {
      itemCode: "Item code",
      orderUnitCode: "Order unit",
      trackStock: "Stock?",
      lot: "Lot",
      bestBefore: "Best before date",
      expiry: "Expiration date",
      patientCode: "PatNr",
    },
    export: {
      exportStatus: "Export status",
      exportReference: "Export reference",
      exportResult: "Export result",
    },
    item: {
      unitName: "Unit",
      restockPullType: "RPT",
      allowCalculatedSignature: "ACS",
    },
    tradeItem: {
      unitCode: "Unit code",
      factor: "Factor",
      defaultUnitCode: "PC",
    },
    foreignItem: {
      itemCode: "PMS item no.",
    },
    itemBlock: {
      code: "Code (QR)"
    },
    supplier: {
      supplierCode: "Supplier no.",
      supplierCodeTitle: "Accounts payable code",
      customerCode: "Customer no.",
      customerCodeTitle: "Accounts receivable code",
      assignedSupplier: "Assigned supplier",
      assignedItems: "Assigned items",
      itemCode: "REF",
      cultureName: "Email language",
      cultureNameTitle: "Language used when sending order emails to this supplier",
      autoConfirmOrder: "Auto-confirm order",
      autoConfirmOrderTitle: "The supplier's order is confirmed automatically without asking for a delivery date",
      autoOrderEnabled: "Auto-create orders",
      autoOrderEnabledTitle: "The daily auto-order run will create orders for this supplier's items. When disabled, demands stay in the draft so they can be ordered manually.",
    },
    order: {
      orderedQuantity: "Ordered quantity",
      deliveryDate: "Delivery date",
    },
    fidoCredential: {
      lastUsedPlatformInfo: "Last used platform",
    },
    entraLogin: {
      displayName: "Display name",
    },
    serviceConnection: {
      endpointURL: "Server-URL",
    },
    credential: {
      type: "Credential type",
      username: "Username",
      password: "Password",
      authenticatorSecret: "Authenticator Secret",
    },
    receiving: {
      deliveredQuantity: "Delivered quantity",
    },
    consumption: {
      billable: "Billable",
      billableShort: "Bill",
      nonBillable: "Non-billable",
      nonBillableShort: "Non-bill",
    },
    pms: {
      mandator: "PMS Mandator",
    },
  },
  page: {
    home: {
      heading: "Welcome to Melodi",
    },
    login: {
      heading: "Sign in",
      rememberme: "Remember me",
      signin: "Sign in",
      forgotPassword: "Forgot password?",
    },
    "forgot-password": {
      heading: "Forgot password",
      description: "Enter your email address and we will send you a link to reset your password.",
    },
    "reset-password": {
      heading: "Reset password",
      description: "Enter your new password.",
      confirmPassword: "Confirm password",
      submit: "Submit",
      resetSuccess: "Password has been reset.",
      resetError: "Password has not been reset.",
    },
    "accept-invite": {
      heading: "Register as a new user",
      description: "Enter your name and new password.",
      confirmPassword: "Confirm password",
      submit: "Submit",
      userRegistrationSuccess: "You are successfully registered.",
      userRegistrationError: "User registration failed.",
    },
    profile: {
      developer: "Developer",
      manageThisSettingOnDesktop: "Manage this setting on desktop",
      apiKey: "API Key",
      passkeys: "Passkeys",
      generateApiKey: "Generate API Key",
      removeApiKey: "Remove API Key",
      generateApiKeyTitle: "API key",
      apiKeyReplaceWarning: "Generating a new API key will invalidate the current key.",
      apiKeyShownOnceWarning: "The API key will only be shown once. Make sure to save it before leaving this page.",
      apiKeyCreating: "API Key is being created...",
      apiKeyCreated: "API Key has been created.",
      apiKeyCreateError: "Failed to create API Key: {error}",
      apiKeyDeleting: "API Key is being deleted...",
      apiKeyDeleted: "API Key has been deleted.",
      apiKeyDeleteError: "Failed to delete API Key: {error}",
      apiKeyCopied: "API Key has been copied to the clipboard.",
      apiKeyCopiedError: "Failed to copy API Key to the clipboard.",
      loginToken: "Login-QR",
      generateLoginToken: "Generate Login-QR",
      removeLoginToken: "Remove Login-QR",
      loginTokenReplaceWarning: "Generating a new Login-QR will invalidate the current QR code.",
      loginTokenCreating: "Login-QR is being created...",
      loginTokenCreated: "Login-QR has been created.",
      loginTokenCreateError: "Failed to create Login-QR: {error}",
      loginTokenDeleting: "Login-QR is being deleted...",
      loginTokenDeleted: "Login-QR has been deleted.",
      loginTokenDeleteError: "Failed to delete Login-QR: {error}",
      loginTokenCopied: "Login-QR has been copied to the clipboard.",
      loginTokenCopiedError: "Failed to copy Login-QR to the clipboard.",
      linkedServicesTitle: "Linked Services",
      addLinkedService: "Add Service",
      logout: "Log out",
      verifyingConnection: "Verifying connection...",
      connectionSuccessful: "Connection verified successfully",
      connectionFailed: "Connection failed",
      serviceLinkSaved: "Service link saved",
      serviceLinkDeleted: "Service link deleted",
      invalidServiceConfiguration: "Invalid service configuration",
      failedToVerifyConnection: "Failed to verify connection",
      failedToSave: "Failed to save",
      failedToDelete: "Failed to delete",
      entraLogins: "Microsoft Account",
      noEntraLogins: "No Microsoft account linked.",
      entraLinkError: "Failed to link Microsoft account.",
    },
    entra: {
      processing: "Processing Microsoft sign-in...",
      missingParameters: "Missing authorization parameters.",
      invalidState: "Invalid authorization state.",
      unknownError: "An unknown error occurred.",
    },
    "manage-tenants": {
      form: {
        title: "Manage Tenants",
      },
      tenantCreated: "Tenant {name} created",
      tenantUpdated: "Tenant {name} updated",
      tenantDeleted: "Tenant {name} deleted",
      siteCreated: "Site {name} created",
      siteUpdated: "Site {name} updated",
      siteDeleted: "Site {name} deleted",
    },
    "manage-users": {
      form: {
        title: "Manage Users",
        inviteUser: "Invite user",
      },
      newUserTitle: "New user",
      newUserEllipsis: "New user...",
      usersList: "Users",
      user: "User",
      deleteUser: "Delete user",
      deleteUserConfirmation: "Are you sure you want to delete this user?",
      inviteUserSuccess: "User invited",
      inviteUserError: "Failed to invite user: {error}",
      selectAtLeastOneRole: "Select at least one role!",
      userChangSaveSuccess: "User changes saved",
      userChangeSaveError: "Failed to save user changes: {error}",
    },
    supplier: {
      deleteConfirmTitle: "Delete Supplier",
      deleteConfirmMessage: "Are you sure you want to delete supplier '{supplierName}' ({supplierCode})?",
    },
    site: {
      title: "Select your site",
    },
    item: {
      table: {
        description: "Description",
        baseUnitCode: "Unit Code",
        consumerUnitCode: "Consumer Unit Code",
        consumerUnitName: "GTIN",
        logisticUnitCode: "Logistic Unit Code",
        logisticUnitName: "Logistic Unit",
        logisticUnitFactor: "Logistic Unit Factor",
        tracking: "Tracking",
        trackLotNumber: "Lot?",
        trackBestBeforeDate: "Best Before Date?",
        trackExpirationDate: "Expiration Date?",
        bestBeforeLeadTime: "Best Before Lead Time",
        expirationLeadTime: "Expiration Lead Time",
        isBillable: "Billable?",
        isBillableShort: "BL",
        canOrderManually: "Manually orderable?",
        requiresLabel: "Label?",
        allowCalculateLot: "Autom. book lot?",
      },
      form: {
        description: "Description",
        mainImage: "Product image",
        sizeImage: "Dimensions image",
        sizeMiniImage: "Small dimensions image",
        defaultLabelQuantity: "Quantity Bin",
        defaultLabelTemplate: "Default label",
        restockPullType: "Restock type",
      },
      saved: "Item saved",
      saveError: "Error while saving",
      openOrders: {
        title: "Open orders",
        openQuantity: "Open",
        replacementOf: "Replacement: {code} ({name})",
      },
      draftCart: {
        title: "In cart",
      },
    },
    info: {
      form: {
        title: "Info",
        barcodeOrItemCode: "Barcode or item code",
      },
    },
    device: {
      screen: "Screen",
      displayResolution: "Display resolution",
      displayViewport: "Display viewport",
      network: "Network",
      remoteAddress: "Remote address",
      userAgent: "User agent",
    },
    stock: {
      successMessage: "Stocks changed",
      errorMessage: "Error changing item: {item}",
      itemSourceAll: "Source",
      itemSourceMelodi: "Melodi",
      itemSourceExternal: "External",
    },
    stockDemand: {
      table: {
        quantityDemand: "Demanded quantity",
        quantityOrdered: "Ordered quantity",
        quantityDelivered: "Delivered quantity",
        stockQuantity: "Current stock",
        stockHistory: "Stock history",
      },
    },
    stockReceipt: {
      form: {
        title: "Stock receipt",
        confirm: "Book receipt",
      },
      successMessage: "{quantity} {unit} added to stock",
      errorMessage: "Failed to book receipt: {error}",
    },
    stockIssue: {
      form: {
        title: "Stock issue",
        confirm: "Book issue",
      },
      successMessage: "{quantity} {unit} removed from stock",
      errorMessage: "Failed to book issue: {error}",
    },
    labelPrint: {
      form: {
        title: "Print",
        confirm: "Print label",
      },
      successMessage: "Label send to printer {printer}",
      noTradeItemDefined: "Item {itemCode} has no tradeitem!",
    },
    labelPrinter: {
      table: {
        address: "Network address",
      },
      form: {
        address: "Network address",
        confirm: "Save printer",
      },
      saved: "Saved printer",
      saveError: "Error while saving",
      deleteError: "Error while deleting",
      deleteConfirmTitle: "Delete Label Printer",
      deleteConfirmMessage: "Are you sure you want to delete label printer '{code}'?",
      deletedSuccessfully: "Label printer '{code}' deleted successfully",
    },
    labelTemplate: {
      table: {
        templateContent: "Label template",
      },
      form: {
        templateContent: "Label template",
        confirm: "Save label",
      },
      saved: "Saved label",
      saveError: "Error while saving",
      deleteError: "Error while deleting",
      deleteConfirmTitle: "Delete Label Template",
      deleteConfirmMessage: "Are you sure you want to delete label template '{code}'?",
      deletedSuccessfully: "Label template '{code}' deleted successfully",
    },
    delivery: {
      form: {
        deliveryCode: "Delivery code",
        deliveryCodeHelp: "Scan or enter the delivery code",
        book: "Receive delivery",
      },
      list: {
        title: "Deliveries",
      },
      notFoundError: "Delivery not found",
      deliveryNotFoundError: "Delivery {deliveryCode} not found",
      differentSiteWarning: "Delivery is for a different site",
      completeError: "Failed to book delivery: {error}",
      completed: "Delivery {deliveryCode} booked",
    },
    order: {
      form: {
        orderCode: "Order code",
        orderCodeHelp: "Scan or enter the order code",
      },
      notFoundError: "Order not found",
      orderNotFoundError: "Order {orderCode} not found",
      notInProgressError: "Order {orderCode} is not in progress and cannot be received",
      acceptError: "Failed to accept order: {error}",
      accepted: "Order {orderCode} accepted",
    },
    "order-create": {
      nothingToOrder: "Nothing to order",
      orderSaving: "Saving order...",
      orderSaved: "Order saved: {orderCode}",
      ordersSaved: "Order(s) saved",
      orderSaveError: "Failed to save order: {error}",
      quantitiesConfirmedFor: "{quantity} {unitCode} confirmed for {date}",
      quantitiesOrderedSince: "{quantity} {unitCode} ordered since {date}",
      addedToOrderDraft: "Item added to cart",
      addToOrderDraftError: "Failed to add item to cart",
      help: {
        title: "Page help",
        topics: {
          placeOrder: {
            title: "Place order",
            description: "Creates one order per supplier from the items in the cart and sends each supplier an order email in their configured language. After this the cart is emptied and you are taken back to the order list.",
          },
          fillDemands: {
            title: "Sync demands",
            description: "Adds Min/Max-managed items with current stock demand to the cart. Quantities account for already-open orders and are rounded up to the supplier's order unit.",
          },
          autoOrder: {
            title: "Daily auto-order",
            description: "Every day at 20:00 the system automatically places orders for Min/Max items based on the current demand — the same logic shown by Sync demands. This includes items that are below their minimum stock at that moment, even if they were not added manually.",
          },
        },
      },
    },
    consumption: {
      notFoundError: "Consumption not found",
      acceptError: "Failed to accept consumption: {error}",
      accepted: "Consumption {referenceCode} accepted",
      retryExport: "Export consumption",
      retryingExport: "Retrying consumption export...",
      exportSuccess: "Consumption {referenceCode} export successful",
      exportRetryError: "Failed to retry consumption export: {error}",
      cancelExport: "Cancel consumption export",
      exportCancelError: "Failed to cancel consumption export: {error}",
      exportCancelled: "Consumption {referenceCode} export cancelled",
      nonBillableDescription: "This consumption is not billable and will only decrease stock respectively but not export to PMS.",
    },
    "consumption-create": {
      consumptionSaving: "Saving consumption...",
    },
    "item-label": {
      captureTitle: "Capture label",
      confirm: "Add label",
    },
    itemBlock: {
      deleteConfirmTitle: "Delete Item Block",
      deleteConfirmMessage: "Are you sure you want to delete item block '{itemBlockName}' ({itemBlockCode})?",
      deletedSuccessfully: "Item block '{itemBlockCode}' deleted successfully"
    },
    statistics: {
      labels: {
        itemIssues: "consumption / week",
        maxStock: "max stock",
        today: "today",
      },
    },
  },
};

export default messages;
